import {Http} from '../../../Data/config/Http';
import {LoginCredentials} from '../repository/AuthRepository';
import {LoginData, LoginResponseDTO, LogoutResponseDTO, GetCurrentUserResponseDTO} from '../models/auth.dto';
import {API_ROUTES} from '../../../constants/apiRoutes';
import {unwrapResponse, handleDataSourceError} from '../../../utils/errorHelpers';
import type {BaseResponse} from '../../../Data/types/BaseResponse';
import type {EffectivePermissionDTO} from '../models/auth.dto';

export class AuthAPIDataSource {

  constructor () {
    // Authentication data source initialization
  }

  async login (credentials: LoginCredentials): Promise<{data: LoginData; stat_message: string}> {
    try {
      const loginRequest = {
        username: credentials.username,
        password: credentials.password,
        device_info: credentials.device_info,
        latitude: 0,
        longitude: 0
      };
      // Response is BaseResponse<LoginData>
      const response = await Http.post<BaseResponse<LoginData>>(API_ROUTES.AUTH.LOGIN, loginRequest);
      const data = unwrapResponse(response.data, 'فشل تسجيل الدخول');
      return {
        data,
        stat_message: response.data.stat_message || 'تم تسجيل الدخول بنجاح'
      };
    } catch (error) {
      handleDataSourceError(error);
    }
  }

  async logout (): Promise<LogoutResponseDTO> {
    try {
      const response = await Http.post<BaseResponse<LogoutResponseDTO>>(API_ROUTES.AUTH.LOGOUT, {});
      return unwrapResponse(response.data, 'فشل تسجيل الخروج');
    } catch (error) {
      handleDataSourceError(error);
    }
  }

  async getCurrentUser (): Promise<GetCurrentUserResponseDTO> {
    try {
      // استخدام /users/me بدلاً من استخراج userId من التوكن
      const userRoute = API_ROUTES.USERS.ME;
      const response = await Http.get<BaseResponse<GetCurrentUserResponseDTO>>(userRoute);
      const data = unwrapResponse(response.data, 'لم يتم العثور على بيانات المستخدم');
      return response.data as GetCurrentUserResponseDTO;
    } catch (error) {
      handleDataSourceError(error);
    }
  }

  /**
   * Self-service password change for the logged-in user. The backend verifies
   * the current password before applying the new one.
   */
  async changePassword (currentPassword: string, newPassword: string): Promise<string> {
    try {
      const response = await Http.put<BaseResponse<null>>(
        API_ROUTES.USERS.CHANGE_PASSWORD,
        {currentPassword, newPassword}
      );
      return response.data.stat_message || 'تم تغيير كلمة المرور بنجاح';
    } catch (error) {
      handleDataSourceError(error);
    }
  }

  async getUserEffectivePermissions (userId: number): Promise<EffectivePermissionDTO[]> {
    const permissionsRoute = API_ROUTES.PERMISSIONS.USERS.EFFECTIVE(userId.toString());

    try {
      const response = await Http.get<BaseResponse<EffectivePermissionDTO[]>>(permissionsRoute);
      const payload = response?.data;

      if (payload && typeof payload === 'object' && 'stat_code' in payload) {
        return Array.isArray(payload.data) ? payload.data : [];
      }

      if (Array.isArray(payload)) {
        return payload;
      }

      return [];
    } catch (error) {
      handleDataSourceError(error);
    }
  }
}
